// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    background: var(--bg-secondary);
    border-bottom: 1px solid var(--border-color);
    box-shadow: 0 1px 0 var(--border-subtle);
    padding: 0 1.25rem;
    position: relative;
    min-height: 68px;
    max-width: 100vw;
}

.navbar-brand {
    font-family: var(--font);
    flex-shrink: 0;
    max-width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    pointer-events: auto;
}

.navbar-brand-button {
    border: none;
    background: transparent;
    padding: 0.2rem 0;
    margin: 0;
    transition: transform 0.2s ease;
}

.navbar-brand-button:hover {
    transform: translateY(-1px);
}

.navbar-brand-button:active {
    transform: translateY(0);
}

.navbar-brand-lockup {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    font-size: clamp(1.15rem, 2.8vw, 1.45rem);
    line-height: 1.15;
}

/* Аббревиатура — компактная «плашка» в духе налогового режима */
.navbar-brand-usn {
    font-size: 0.72em;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--accent-light);
    padding: 0.2rem 0.45rem 0.22rem;
    border-radius: 6px;
    background: linear-gradient(145deg, rgba(59, 130, 246, 0.18) 0%, rgba(59, 130, 246, 0.06) 100%);
    border: 1px solid rgba(96, 165, 250, 0.35);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;
}

.navbar-brand-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: linear-gradient(145deg, var(--accent-light), var(--accent));
    opacity: 0.9;
    flex-shrink: 0;
    box-shadow: 0 0 10px var(--accent-glow);
}

.navbar-brand-profi {
    font-weight: 700;
    letter-spacing: -0.03em;
    background: linear-gradient(
        125deg,
        #f4f4f8 0%,
        var(--text-primary) 35%,
        var(--accent-light) 88%,
        #93c5fd 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    text-shadow: none;
    filter: drop-shadow(0 0 20px rgba(96, 165, 250, 0.12));
}

.navbar-brand-button:hover .navbar-brand-usn {
    border-color: rgba(96, 165, 250, 0.55);
    background: linear-gradient(145deg, rgba(59, 130, 246, 0.28) 0%, rgba(59, 130, 246, 0.1) 100%);
}

.navbar-brand-button:hover .navbar-brand-profi {
    filter: drop-shadow(0 0 14px rgba(96, 165, 250, 0.25)) brightness(1.06);
}

/* Бургер — только на мобильных */
.navbar-burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 44px;
    height: 44px;
    padding: 10px;
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    cursor: pointer;
    z-index: 102;
    transition: background 0.2s, border-color 0.2s;
}
.navbar-burger:hover {
    background: var(--input-bg);
    border-color: var(--accent);
}
.navbar-burger-line {
    display: block;
    height: 2px;
    width: 100%;
    max-width: 22px;
    margin: 0 auto;
    background: var(--text-primary);
    border-radius: 1px;
    transition: transform 0.25s, opacity 0.25s;
}
.navbar-menu-open .navbar-burger .navbar-burger-line:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
}
.navbar-menu-open .navbar-burger .navbar-burger-line:nth-child(2) {
    opacity: 0;
}
.navbar-menu-open .navbar-burger .navbar-burger-line:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
}

/* Навигация — десктоп: строго по центру через grid */
.navbar-nav {
    display: flex;
    align-items: center;
    flex: 1 1;
    min-width: 0;
}
.navbar-nav-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 0.5rem;
}
.navbar-nav-center {
    flex: 1 1;
    display: flex;
    justify-content: center;
    min-width: 0;
}
.navbar-nav-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 0.5rem;
}
.navbar-nav-right {
    flex-shrink: 0;
}

/* Десктоп: grid для точного центра (три колонки 1fr | auto | 1fr) */
@media (min-width: 769px) {
    .navbar {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }
    .navbar-brand {
        grid-column: 1;
        justify-self: start;
    }
    .navbar-burger {
        grid-column: 1;
        grid-row: 1;
        justify-self: end;
    }
    .navbar-nav,
    .navbar-nav-list {
        display: contents;
    }
    .navbar-nav-center {
        grid-column: 2;
        justify-self: center;
        flex: none;
    }
    .navbar-nav-right {
        grid-column: 3;
        justify-self: end;
    }
}
.navbar-link,
.navbar-link-logout,
.navbar-link-login {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.55rem 0.9rem;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.95rem;
    min-height: 44px;
    text-decoration: none;
    color: var(--text-primary);
    background: transparent;
    border: none;
    cursor: pointer;
    font-family: inherit;
    transition: background 0.2s, color 0.2s;
}
.navbar-link:hover,
.navbar-link-login:hover {
    background: var(--accent-hover);
    color: white;
}
.navbar-link.active,
.navbar-link-login.active {
    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);
    color: white;
    box-shadow: 0 2px 10px var(--accent-glow);
}
.navbar-link-logout {
    color: #f87171;
}
.navbar-link-logout:hover {
    background: rgba(239, 68, 68, 0.2);
    color: #fca5a5;
}

/* Подложка для мобильного меню */
.navbar-backdrop {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100;
}

/* ————— Мобильная версия (телефон) ————— */
@media (max-width: 768px) {
    .navbar {
        min-height: 52px;
        padding: 0 0.75rem;
    }
    .navbar-brand {
        max-width: 55%;
    }
    .navbar-brand-lockup {
        font-size: 1.05rem;
        gap: 0.35rem;
    }
    .navbar-brand-usn {
        letter-spacing: 0.12em;
        padding: 0.15rem 0.38rem 0.17rem;
    }

    .navbar-burger {
        display: flex;
    }

    .navbar-nav {
        position: fixed;
        top: 0;
        right: 0;
        width: min(320px, 100vw);
        max-width: 100%;
        height: 100vh;
        background: var(--bg-secondary);
        border-left: 1px solid var(--border-color);
        z-index: 101;
        padding: 4.5rem 1rem 1.5rem;
        box-shadow: -8px 0 24px rgba(0, 0, 0, 0.4);
        transform: translateX(100%);
        opacity: 0;
        visibility: hidden;
        transition: transform 0.25s ease, opacity 0.2s, visibility 0.25s;
        overflow-y: auto;
    }
    .navbar-nav.navbar-nav-open {
        transform: translateX(0);
        opacity: 1;
        visibility: visible;
    }

    .navbar-backdrop {
        display: block;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s, visibility 0.2s;
    }
.navbar-menu-open .navbar-backdrop {
    opacity: 1;
    visibility: visible;
}

    .navbar-nav-list {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        gap: 0.5rem;
    }
    .navbar-nav-center {
        flex: none;
        justify-content: stretch;
    }
    .navbar-nav-inner {
        flex-direction: column;
        align-items: stretch;
        gap: 0.5rem;
    }
    .navbar-nav-inner li,
    .navbar-nav-list li {
        width: 100%;
    }
    .navbar-link,
    .navbar-link-logout,
    .navbar-link-login {
        width: 100%;
        padding: 0.85rem 1rem;
        min-height: 48px;
        border-radius: 10px;
        font-size: 1rem;
        justify-content: flex-start;
        text-align: left;
    }
    .navbar-link.active,
    .navbar-link-login.active {
        background: var(--accent);
        color: white;
    }
    .navbar-link-login {
        background: var(--accent);
        color: white;
        justify-content: center;
    }
    .navbar-link-login:hover {
        background: var(--accent-hover);
    }
    .navbar-link-logout {
        margin-top: 0.5rem;
        padding-top: 0.85rem;
        border-top: 1px solid var(--border-color);
        justify-content: center;
        color: #f87171;
    }
}

@media (max-width: 480px) {
    .navbar {
        min-height: 48px;
        padding: 0 0.5rem;
    }
    .navbar-brand {
        max-width: 50%;
    }
    .navbar-brand-lockup {
        font-size: 0.95rem;
    }
    .navbar-burger {
        width: 40px;
        height: 40px;
    }
    .navbar-nav {
        width: min(280px, 100%);
        padding: 4rem 0.75rem 1rem;
    }
    .navbar-link,
    .navbar-link-logout,
    .navbar-link-login {
        padding: 0.75rem 1rem;
        min-height: 44px;
        font-size: 0.95rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,+BAA+B;IAC/B,4CAA4C;IAC5C,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA,gEAAgE;AAChE;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,+BAA+B;IAC/B,kBAAkB;IAClB,+FAA+F;IAC/F,0CAA0C;IAC1C,mDAAmD;AACvD;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,uEAAuE;IACvE,YAAY;IACZ,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB;;;;;;KAMC;IACD,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,sDAAsD;AAC1D;;AAEA;IACI,sCAAsC;IACtC,8FAA8F;AAClG;;AAEA;IACI,uEAAuE;AAC3E;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,8CAA8C;AAClD;AACA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,0CAA0C;AAC9C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,UAAU;AACd;AACA;IACI,0CAA0C;AAC9C;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,WAAW;AACf;AACA;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,WAAW;AACf;AACA;IACI,cAAc;AAClB;;AAEA,oEAAoE;AACpE;IACI;QACI,aAAa;QACb,mCAAmC;QACnC,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;IACrB;IACA;;QAEI,iBAAiB;IACrB;IACA;QACI,cAAc;QACd,oBAAoB;QACpB,UAAU;IACd;IACA;QACI,cAAc;QACd,iBAAiB;IACrB;AACJ;AACA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,uCAAuC;AAC3C;AACA;;IAEI,+BAA+B;IAC/B,YAAY;AAChB;AACA;;IAEI,+EAA+E;IAC/E,YAAY;IACZ,yCAAyC;AAC7C;AACA;IACI,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,YAAY;AAChB;;AAEA,2CAA2C;AAC3C;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,sBAAsB;QACtB,gCAAgC;IACpC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,MAAM;QACN,QAAQ;QACR,wBAAwB;QACxB,eAAe;QACf,aAAa;QACb,+BAA+B;QAC/B,0CAA0C;QAC1C,YAAY;QACZ,2BAA2B;QAC3B,0CAA0C;QAC1C,2BAA2B;QAC3B,UAAU;QACV,kBAAkB;QAClB,gEAAgE;QAChE,gBAAgB;IACpB;IACA;QACI,wBAAwB;QACxB,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,UAAU;QACV,kBAAkB;QAClB,yCAAyC;IAC7C;AACJ;IACI,UAAU;IACV,mBAAmB;AACvB;;IAEI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,2BAA2B;QAC3B,WAAW;IACf;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,WAAW;IACf;IACA;;QAEI,WAAW;IACf;IACA;;;QAGI,WAAW;QACX,qBAAqB;QACrB,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,2BAA2B;QAC3B,gBAAgB;IACpB;IACA;;QAEI,yBAAyB;QACzB,YAAY;IAChB;IACA;QACI,yBAAyB;QACzB,YAAY;QACZ,uBAAuB;IAC3B;IACA;QACI,+BAA+B;IACnC;IACA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,yCAAyC;QACzC,uBAAuB;QACvB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,uBAAuB;QACvB,0BAA0B;IAC9B;IACA;;;QAGI,qBAAqB;QACrB,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":[".navbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    background: var(--bg-secondary);\n    border-bottom: 1px solid var(--border-color);\n    box-shadow: 0 1px 0 var(--border-subtle);\n    padding: 0 1.25rem;\n    position: relative;\n    min-height: 68px;\n    max-width: 100vw;\n}\n\n.navbar-brand {\n    font-family: var(--font);\n    flex-shrink: 0;\n    max-width: 50%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.navbar-brand-button {\n    border: none;\n    background: transparent;\n    padding: 0.2rem 0;\n    margin: 0;\n    transition: transform 0.2s ease;\n}\n\n.navbar-brand-button:hover {\n    transform: translateY(-1px);\n}\n\n.navbar-brand-button:active {\n    transform: translateY(0);\n}\n\n.navbar-brand-lockup {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.45rem;\n    font-size: clamp(1.15rem, 2.8vw, 1.45rem);\n    line-height: 1.15;\n}\n\n/* Аббревиатура — компактная «плашка» в духе налогового режима */\n.navbar-brand-usn {\n    font-size: 0.72em;\n    font-weight: 800;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    color: var(--accent-light);\n    padding: 0.2rem 0.45rem 0.22rem;\n    border-radius: 6px;\n    background: linear-gradient(145deg, rgba(59, 130, 246, 0.18) 0%, rgba(59, 130, 246, 0.06) 100%);\n    border: 1px solid rgba(96, 165, 250, 0.35);\n    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.04) inset;\n}\n\n.navbar-brand-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: linear-gradient(145deg, var(--accent-light), var(--accent));\n    opacity: 0.9;\n    flex-shrink: 0;\n    box-shadow: 0 0 10px var(--accent-glow);\n}\n\n.navbar-brand-profi {\n    font-weight: 700;\n    letter-spacing: -0.03em;\n    background: linear-gradient(\n        125deg,\n        #f4f4f8 0%,\n        var(--text-primary) 35%,\n        var(--accent-light) 88%,\n        #93c5fd 100%\n    );\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    text-shadow: none;\n    filter: drop-shadow(0 0 20px rgba(96, 165, 250, 0.12));\n}\n\n.navbar-brand-button:hover .navbar-brand-usn {\n    border-color: rgba(96, 165, 250, 0.55);\n    background: linear-gradient(145deg, rgba(59, 130, 246, 0.28) 0%, rgba(59, 130, 246, 0.1) 100%);\n}\n\n.navbar-brand-button:hover .navbar-brand-profi {\n    filter: drop-shadow(0 0 14px rgba(96, 165, 250, 0.25)) brightness(1.06);\n}\n\n/* Бургер — только на мобильных */\n.navbar-burger {\n    display: none;\n    flex-direction: column;\n    justify-content: center;\n    gap: 5px;\n    width: 44px;\n    height: 44px;\n    padding: 10px;\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    cursor: pointer;\n    z-index: 102;\n    transition: background 0.2s, border-color 0.2s;\n}\n.navbar-burger:hover {\n    background: var(--input-bg);\n    border-color: var(--accent);\n}\n.navbar-burger-line {\n    display: block;\n    height: 2px;\n    width: 100%;\n    max-width: 22px;\n    margin: 0 auto;\n    background: var(--text-primary);\n    border-radius: 1px;\n    transition: transform 0.25s, opacity 0.25s;\n}\n.navbar-menu-open .navbar-burger .navbar-burger-line:nth-child(1) {\n    transform: translateY(7px) rotate(45deg);\n}\n.navbar-menu-open .navbar-burger .navbar-burger-line:nth-child(2) {\n    opacity: 0;\n}\n.navbar-menu-open .navbar-burger .navbar-burger-line:nth-child(3) {\n    transform: translateY(-7px) rotate(-45deg);\n}\n\n/* Навигация — десктоп: строго по центру через grid */\n.navbar-nav {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n}\n.navbar-nav-list {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    gap: 0.5rem;\n}\n.navbar-nav-center {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    min-width: 0;\n}\n.navbar-nav-inner {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    gap: 0.5rem;\n}\n.navbar-nav-right {\n    flex-shrink: 0;\n}\n\n/* Десктоп: grid для точного центра (три колонки 1fr | auto | 1fr) */\n@media (min-width: 769px) {\n    .navbar {\n        display: grid;\n        grid-template-columns: 1fr auto 1fr;\n        align-items: center;\n    }\n    .navbar-brand {\n        grid-column: 1;\n        justify-self: start;\n    }\n    .navbar-burger {\n        grid-column: 1;\n        grid-row: 1;\n        justify-self: end;\n    }\n    .navbar-nav,\n    .navbar-nav-list {\n        display: contents;\n    }\n    .navbar-nav-center {\n        grid-column: 2;\n        justify-self: center;\n        flex: none;\n    }\n    .navbar-nav-right {\n        grid-column: 3;\n        justify-self: end;\n    }\n}\n.navbar-link,\n.navbar-link-logout,\n.navbar-link-login {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.55rem 0.9rem;\n    border-radius: 8px;\n    font-weight: 500;\n    font-size: 0.95rem;\n    min-height: 44px;\n    text-decoration: none;\n    color: var(--text-primary);\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-family: inherit;\n    transition: background 0.2s, color 0.2s;\n}\n.navbar-link:hover,\n.navbar-link-login:hover {\n    background: var(--accent-hover);\n    color: white;\n}\n.navbar-link.active,\n.navbar-link-login.active {\n    background: linear-gradient(135deg, var(--accent) 0%, var(--accent-hover) 100%);\n    color: white;\n    box-shadow: 0 2px 10px var(--accent-glow);\n}\n.navbar-link-logout {\n    color: #f87171;\n}\n.navbar-link-logout:hover {\n    background: rgba(239, 68, 68, 0.2);\n    color: #fca5a5;\n}\n\n/* Подложка для мобильного меню */\n.navbar-backdrop {\n    display: none;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 100;\n}\n\n/* ————— Мобильная версия (телефон) ————— */\n@media (max-width: 768px) {\n    .navbar {\n        min-height: 52px;\n        padding: 0 0.75rem;\n    }\n    .navbar-brand {\n        max-width: 55%;\n    }\n    .navbar-brand-lockup {\n        font-size: 1.05rem;\n        gap: 0.35rem;\n    }\n    .navbar-brand-usn {\n        letter-spacing: 0.12em;\n        padding: 0.15rem 0.38rem 0.17rem;\n    }\n\n    .navbar-burger {\n        display: flex;\n    }\n\n    .navbar-nav {\n        position: fixed;\n        top: 0;\n        right: 0;\n        width: min(320px, 100vw);\n        max-width: 100%;\n        height: 100vh;\n        background: var(--bg-secondary);\n        border-left: 1px solid var(--border-color);\n        z-index: 101;\n        padding: 4.5rem 1rem 1.5rem;\n        box-shadow: -8px 0 24px rgba(0, 0, 0, 0.4);\n        transform: translateX(100%);\n        opacity: 0;\n        visibility: hidden;\n        transition: transform 0.25s ease, opacity 0.2s, visibility 0.25s;\n        overflow-y: auto;\n    }\n    .navbar-nav.navbar-nav-open {\n        transform: translateX(0);\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .navbar-backdrop {\n        display: block;\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity 0.2s, visibility 0.2s;\n    }\n.navbar-menu-open .navbar-backdrop {\n    opacity: 1;\n    visibility: visible;\n}\n\n    .navbar-nav-list {\n        flex-direction: column;\n        align-items: stretch;\n        justify-content: flex-start;\n        gap: 0.5rem;\n    }\n    .navbar-nav-center {\n        flex: none;\n        justify-content: stretch;\n    }\n    .navbar-nav-inner {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 0.5rem;\n    }\n    .navbar-nav-inner li,\n    .navbar-nav-list li {\n        width: 100%;\n    }\n    .navbar-link,\n    .navbar-link-logout,\n    .navbar-link-login {\n        width: 100%;\n        padding: 0.85rem 1rem;\n        min-height: 48px;\n        border-radius: 10px;\n        font-size: 1rem;\n        justify-content: flex-start;\n        text-align: left;\n    }\n    .navbar-link.active,\n    .navbar-link-login.active {\n        background: var(--accent);\n        color: white;\n    }\n    .navbar-link-login {\n        background: var(--accent);\n        color: white;\n        justify-content: center;\n    }\n    .navbar-link-login:hover {\n        background: var(--accent-hover);\n    }\n    .navbar-link-logout {\n        margin-top: 0.5rem;\n        padding-top: 0.85rem;\n        border-top: 1px solid var(--border-color);\n        justify-content: center;\n        color: #f87171;\n    }\n}\n\n@media (max-width: 480px) {\n    .navbar {\n        min-height: 48px;\n        padding: 0 0.5rem;\n    }\n    .navbar-brand {\n        max-width: 50%;\n    }\n    .navbar-brand-lockup {\n        font-size: 0.95rem;\n    }\n    .navbar-burger {\n        width: 40px;\n        height: 40px;\n    }\n    .navbar-nav {\n        width: min(280px, 100%);\n        padding: 4rem 0.75rem 1rem;\n    }\n    .navbar-link,\n    .navbar-link-logout,\n    .navbar-link-login {\n        padding: 0.75rem 1rem;\n        min-height: 44px;\n        font-size: 0.95rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
